import simpleBuilder from '@/helpers/dtos/simpleBuilder';
const balanceDueFromAPIMappingKeys = {
    saldoAvencerIdProduto: 'productId',
    saldoAvencerValor: 'value',
    saldoAvencerDataLeitura: 'date',
};
export default simpleBuilder(balanceDueFromAPIMappingKeys);
